
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7; //self.$app.dialog.preloader("Please Wait");

    self.setupGoogleMaps(); //self.checkNotificationsCount();

    setTimeout(function () {//self.checkSilentUpdate();
    }, 2000);
  },
  beforeMount: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7; // $$(".view-main").on("tab:show", function () {
    //     self.loadData();
    // });

    self.loadData();
  },
  data: function () {
    return {
      location: null,
      locations: [],
      marker: null,
      markers: [],
      map: null,
      recenterAttached: false,
      orignalCenter: null,
      orignalZoom: null,
      user: window.identity
    };
  },
  on: {
    pageBeforeIn: function (a, b, c) {
      var self = this;
      self.$setState({
        user: window.identity
      }, function () {}); //console.log(">>>>>>>",a,b,c);

      if (b.direction == "backward") {
        self.loadData();
        self.getNewLocations();
      }
    }
  },
  methods: {
    showUpdateModal(link) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var alert = self.$app.dialog.alert('A new version is available to download. Please update to continue using the app?', function () {
        if (window.cordova) {
          window.cordova.InAppBrowser.open(link, '_system');
        } else {
          window.open(link, "_system");
        }
      });
      alert.on('close', () => {
        self.showUpdateModal(link);
      });
      console.log(alert);
    },

    checkSilentUpdate() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.request({
        url: Url.to("data/check-update"),
        data: {
          version: window.appVersionLabel,
          platform: self.$app.device.os
        },
        preloader: false,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(data);

          if (data['update']) {
            console.log("UPDATE REQUIRED");
            self.showUpdateModal(data['link']);
          } else {
            console.log("Latest Version");
          }

          setTimeout(() => {
            self.checkSilentUpdate();
          }, 5 * 60 * 1000); //every 5 minutes
        }
      });
    },

    goToEditProfile: function () {
      var self = this;
      var app = self.$app; //var view = app.views.get(".view-main");

      app.views.current.router.navigate("/edit-profile/"); //app.tab.show(".view-account", ".tab-link[href='#view-account']",false);
    },

    checkNotificationsCount() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("notification/unread"),
        preloader: false,
        progress: false,
        success: function (data, status, xhr) {
          //console.log(data);
          if (data['count'] > 0) {
            $$("#notifications-count").text(data['count']);
            $$("#notifications-count").removeClass("display-none");
          }

          setTimeout(() => {
            self.checkNotificationsCount();
          }, 30000);
        }
      });
    },

    setupGoogleMaps() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      setTimeout(function () {
        if (!window.google) {
          self.setupGoogleMaps();
        } else {
          //self.$app.dialog.close();
          var map = new google.maps.Map(document.getElementById('default-map'), {
            center: {
              lat: 33.9053496,
              lng: 35.9241833
            },
            zoom: 8,
            //maxZoom: 15,
            disableDefaultUI: true,
            mapTypeId: google.maps.MapTypeId.HYBRID,
            styles: [{
              "featureType": "administrative",
              "elementType": "all",
              "stylers": [{
                "saturation": "-100"
              }]
            }, {
              "featureType": "administrative.province",
              "elementType": "all",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "featureType": "landscape",
              "elementType": "all",
              "stylers": [{
                "saturation": -100
              }, {
                "lightness": 65
              }, {
                "visibility": "on"
              }]
            }, {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [{
                "saturation": -100
              }, {
                "lightness": "50"
              }, {
                "visibility": "simplified"
              }]
            }, {
              "featureType": "road",
              "elementType": "all",
              "stylers": [{
                "saturation": "-100"
              }]
            }, {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [{
                "visibility": "simplified"
              }]
            }, {
              "featureType": "road.arterial",
              "elementType": "all",
              "stylers": [{
                "lightness": "30"
              }]
            }, {
              "featureType": "road.local",
              "elementType": "all",
              "stylers": [{
                "lightness": "40"
              }]
            }, {
              "featureType": "transit",
              "elementType": "all",
              "stylers": [{
                "saturation": -100
              }, {
                "visibility": "simplified"
              }]
            }, {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [{
                "hue": "#378cff"
              }, {
                "lightness": 0 //-25

              }, {
                "saturation": 0 //-97

              }]
            }, {
              "featureType": "water",
              "elementType": "labels",
              "stylers": [{
                "lightness": -0
              }, {
                "saturation": -0
              }]
            }],
            mapTypeControl: true,
            mapTypeControlOptions: {
              mapTypeIds: [google.maps.MapTypeId.HYBRID, google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.TERRAIN],
              position: google.maps.ControlPosition.LEFT_TOP,
              style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
            }
          });
          self.$setState({
            map: map
          }, function () {
            self.loadData();
            self.getNewLocations();
          });
        }
      }, 100);
    },

    setLocations: function (locations) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$setState({
        locations: locations
      }, function () {
        var i = 0;

        while (!self.map && i < 15000) {
          i++; //console.log(i);
          //wait
        }

        if (self.map) {
          for (var x = 0; x < self.markers.length; x++) {
            self.markers[x].setMap(null);
          }

          self.markers = [];
          let bounds = new google.maps.LatLngBounds();
          locations.forEach(function (location, index) {
            var marker = new google.maps.Marker({
              position: {
                lat: parseFloat(location.latitude),
                lng: parseFloat(location.longitude)
              },
              map: self.map,
              icon: {
                url: 'https://static.app.mitsulift.com/images/map-marker.svg',
                // This marker is 20 pixels wide by 32 pixels high.
                size: new google.maps.Size(30, 42),
                scaledSize: new google.maps.Size(30, 42),
                // The origin for this image is (0, 0).
                origin: new google.maps.Point(0, 0),
                // The anchor for this image is the base of the flagpole at (0, 32).
                anchor: new google.maps.Point(15, 42)
              }
            });
            marker.addListener("click", () => {
              self.openLocation(location.id);
            });
            self.markers.push(marker);
            self.map.setZoom(15);
            self.map.setCenter({
              lat: parseFloat(location.latitude),
              lng: parseFloat(location.longitude)
            });
            bounds.extend(marker.getPosition());
          });
          self.map.fitBounds(bounds);

          if (self.markers.length === 0) {
            self.map.setCenter({
              lat: 33.9053496,
              lng: 35.9241833
            });
            self.map.setZoom(7);
          }

          if (self.markers.length === 1) {
            self.map.setZoom(15);
          }

          if (!self.recenterAttached) {
            self.recenterAttached = true;
            self.orignalCenter = self.map.center;
            self.orignalZoom = self.map.zoom;
            self.map.addListener("center_changed", () => {
              window.setTimeout(() => {
                $$(".map-overlay").removeClass("display-none");
              }, 350);
            });
          }
        }
      });
    },
    loadData: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7; //Get locations

      app.request({
        url: Url.to("location/get"),
        preloader: false,
        progress: true,
        success: function (data, status, xhr) {
          self.setLocations(data);
        }
      });
    },
    getNewLocations: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("location/get-new"),
        preloader: false,
        progress: false,
        success: function (data, status, xhr) {
          if (data['new']) {
            var dialog = self.$app.dialog.alert(data['message']);
            $$(dialog.el).find(".dialog-text").addClass("text-align-left");
          }
        }
      });
    },
    openLocation: function (id) {
      //console.log(id);
      var self = this;
      var router = self.$router;
      var location = {};
      self.locations.forEach(function (loc) {
        if (loc.id === id) {
          location = loc;
          return false;
        }
      });
      router.navigate("/location/", {
        context: {
          location: location
        }
      });
    },

    recenterMap() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.map.setZoom(self.orignalZoom);
      self.map.setCenter(self.orignalCenter);
      window.setTimeout(() => {
        $$(".map-overlay").addClass("display-none");
      }, 400);
    }

  },
  id: '2dafc5c8bd',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar navbar-extra-large" data-name="home">\n        <!-- Top Navbar -->\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a class="link back icon-only" href="#">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">My Locations</div>\n                <div class="right">\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n                        My Mitsu\n                        <div class="subtitle-text">My Locations</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <!-- Scrollable page content-->\n        <div class="page-content">\n            <div class="home-page-layout">\n<!--                <div style="flex-grow: 1">-->\n                    <div class="block map-block no-margin no-padding">\n                        <div id="default-map" style="width:100%;height:75vw;max-height:50vh">\n                            <div style="width: 100%;height: 100%;" class="display-flex align-items-center justify-content-center">\n                                <div class="preloader"></div>\n                            </div>\n                        </div>\n                        <div class="map-overlay display-none">\n                            <a @click="recenterMap" class="button bg-color-white button-outline color-primary" href="#" style="border-radius: 50px">\n                                <i class="icon material-icons" style="font-size: 16px">zoom_out_map</i>\n                                Reset\n                            </a>\n                        </div>\n                    </div>\n\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.locations.length>0', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <div class="list no-margin-vertical">\n                        <ul>\n                            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.locations, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <li>\n                                <a @click="openLocation(';
              r += c(ctx_3.id, ctx_3);
              r += ')" class="item-link item-content" href="#">\n                                    <div class="item-inner">\n                                        <div class="item-title">\n                                            ';
              r += c(ctx_3.name, ctx_3);
              r += '\n                                            <div class="item-footer">';
              r += c(ctx_3.code, ctx_3);
              r += ' - ';
              r += c(ctx_3.address, ctx_3);
              r += '</div>\n                                        </div>\n                                        <!--<div class="item-after">Expires in 5 days</div>-->\n                                    </div>\n                                </a>\n                            </li>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        </ul>\n                    </div>\n                    ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n                    <div class="block-title">Welcome to mitsulift</div>\n\n                    <div class="block block-strong no-hairlines display-none">\n                        <p>\n                            Your account is not yet linked to any existing location.<br/>\n                            Tap <strong>Request access</strong> button bellow and fill in any available information you\n                            have.<br/>\n                            Our team will verify your submission and grant access to location\'s info.\n                        </p>\n                    </div>\n                    <div class="list links-list margin-5-0 display-none">\n                        <ul>\n                            <li class="large-gray-link">\n                                <a href="/request-access/">Request access</a>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <div class="block block-strong no-hairlines">\n                        <p>\n                            Your account is not yet linked to any location.<br/>\n                            Tap <strong>Add Location</strong> and enter the location password you received.\n                        </p>\n                    </div>\n                    ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n<!--                </div>-->\n\n                <div class="list links-list  margin-5-0">\n                    <ul>\n                        <li class="large-gray-link"><a href="#" @click="$root.gotToAddLocation">Add a new location</a></li>\n                    </ul>\n                </div>\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="display-none list buttons-list-item margin-5-0">\n                    <ul>\n                        <li>\n                            <a href="#" class="item-content item-link" @click="goToEditProfile">\n                                <div class="item-inner">\n                                    <div class="item-title">\n                                        Your contact details\n                                        <div class="item-footer">';
          r += c(ctx_2.user.name, ctx_2);
          r += ' / ';
          r += c(ctx_2.user.phone_number, ctx_2);
          r += '</div>\n                                    </div>\n                                    <div class="item-after">\n                                        Update\n                                    </div>\n                                </div>\n                            </a>\n                        </li>\n                    </ul>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            </div>\n            <div class="display-none list buttons-list-item margin-5-0-15">\n                <ul>\n                    <li>\n                        <div class="item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    Need help?\n                                    <div class="item-footer">Send us a message or call us</div>\n                                </div>\n                                <div class="item-after">\n                                    <div class="row">\n                                        <a target="_system" class="col button button-outline button-round link external" href="mailto:';
      r += c(ctx_1.$root.email, ctx_1);
      r += '"><i class="icon f7-icons">chat_bubble_fill</i></a>\n                                        <a target="_system" class="col button button-outline button-round link external" href="tel:';
      r += c(ctx_1.$root.phone, ctx_1);
      r += '"><i class="icon f7-icons">phone_fill</i></a>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n\n        </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    